export default {
  filterUsers (users, filters) {
    let filteringUsers = users
    if (filters.username) {
      filteringUsers = filteringUsers.filter((i) => {
        return !(i.username.search(new RegExp(filters.username, 'i')) < 0)
      })
    }
    if (filters.roleName) {
      filteringUsers = filteringUsers.filter((i) => {
        return (i.roles || []).some(role => (role.displayName || role.code || '').toLocaleLowerCase()
          .includes(filters.roleName.toLocaleLowerCase()))
      })
    }
    if (filters.companyName) {
      filteringUsers = filteringUsers.filter((i) => {
        return (i.company?.name || '').toLocaleLowerCase().includes(filters.companyName.toLocaleLowerCase())
      })
    }
    return filteringUsers
  }
}
